import React from "react";
import styles from "./HappyClient.module.css";
import client1 from "assets/client1.png";
import client2 from "assets/client2.png";
import client3 from "assets/client3.png";
import client4 from "assets/client4.png";

const HappyClient = () => {
  const data = [
    {
      name: "Michael Reynolds",
      role: "VP of Engineering, Cloud & FinTech",
      rating: 5,
      description:
        "Provaantech led our legacy .NET modernization to Azure microservices seamlessly. Their engineering pods delivered zero-downtime cutover and strict QA automation that accelerated our release velocity by 4x.",
      image: client1
    },
    {
      name: "Sarah Jenkins",
      role: "Chief Digital Officer, HealthTech",
      rating: 5,
      description:
        "The AI engineering and agentic workflow solutions implemented by Provaantech transformed our operational efficiency. Their deep tech expertise in machine learning made them an invaluable strategic partner.",
      image: client2
    },
    {
      name: "David Chen",
      role: "Director of Architecture, Global Logistics",
      rating: 5,
      description:
        "Setting up our dedicated engineering pod with Provaantech was seamless. Within weeks, their senior engineers were shipping mission-critical features with exceptional architectural rigor and clean code.",
      image: client3
    },
    {
      name: "Elena Rostova",
      role: "Head of QA & DevOps, Enterprise Retail",
      rating: 5,
      description:
        "Provaantech overhauled our test automation framework across distributed systems. Test coverage surged above 90% and regression runs dropped from days to under 45 minutes.",
      image: client4
    }
  ];

  
  return (
    <div className={styles.main}>
      <div>
        <p className={styles.heading}>
          <span>
            Our Happy<span className={styles.back}> Clients</span>
          </span>
        </p>
      </div>
      <div className={styles.carousel}>
        <div className={styles.cardWrapper}>
          {data.concat(data).map((client, index) => (
            <div key={index} className={styles.card}>
              <div className={styles.HappyClientImg}>
                <img
                  src={client.image}
                  alt={client.name}
                  className={styles.image}
                />
                <div className={styles.box}>
                  <h3 className={styles.name}>{client.name}</h3>
                  {client.role && <p className={styles.clientRole}>{client.role}</p>}
                  <div className={styles.rating}>
                    {"★".repeat(client.rating)}
                  </div>
                </div>
              </div>
              <p className={styles.description}>{client.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HappyClient;
